(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProjectController', ProjectController);

    ProjectController.$inject = ['$scope', '$state', 'Project', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$translate'];

    function ProjectController ($scope, $state, Project, ParseLinks, AlertService, paginationConstants, pagingParams, $translate) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.deleteProject = deleteProject;

        loadAll();

        function loadAll () {
            Project.CRUD.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.projects = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        function deleteProject(project) {
            Project.CRUD.delete(project, onSuccess, onError);

            function onSuccess(project) {
                console.log('deleted project');
                loadAll();
            }
            function onError(err) {
                console.log("failed to delete project " + err);
                AlertService.error($translate.instant("abcQualityMatchApp.project.delete.fail"));
            }
        }
    }
})();
